module.exports = __webpack_public_path__ + "static/img/bronze.b25965a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/league-ad-section/bronze.png
// module id = aulx
// module chunks = 35